import React from 'react';

import styles from '../fieldStyles';

import { chunk } from 'buyside/util/arrayHelper';

const CheckboxesField = ({
  field,
  form: { setFieldValue, isSubmitting },
  options,
  numColumns,
  restriction,
  checkboxLabelClassName,
  checkAllField,
  customLabels = {},
  customLabelWrapperClassName
}) => {
  const isOptionType = options[0].hasOwnProperty('value');
  const handleChange = (e, option) => {
    let newValue = field.value;
    if (e.target.checked) {
      if (restriction) {
        const optionValues = isOptionType ? options.map(option => option.value) : options;
        newValue = newValue.filter(el => !optionValues.includes(el));
      }
      if (checkAllField && option === checkAllField) {
        newValue = options;
      } else {
        newValue = newValue.concat(option);
      }
    } else {
      newValue = newValue.filter(el => el !== option);
    }
    setFieldValue(field.name, newValue);
  };
  const optionsColumns = chunk(options, Math.ceil(options.length / numColumns));
  return (
    <div className={styles.checkboxesFieldContainer}>
      {optionsColumns.map((optionsColumn, idx) => (
        <div key={idx} className={styles.checkboxesFieldColumn}>
          {optionsColumn.map((option, idx) => {
            const value = isOptionType ? option.value : option;
            const label = isOptionType ? option.label : option;
            return (
              <div key={idx} className={styles.checkbox}>
                <label className={customLabelWrapperClassName}>
                  <input
                    type="checkbox"
                    onChange={e => handleChange(e, value)}
                    checked={field.value.indexOf(value) !== -1}
                    disabled={isSubmitting}
                  />
                  <div
                    className={
                      checkboxLabelClassName ? checkboxLabelClassName : styles.checkboxLabel
                    }
                  >
                    {label}
                    {customLabels[label] && (
                      <span className={styles.customLabel}>&nbsp;{customLabels[label]}</span>
                    )}
                  </div>
                </label>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default CheckboxesField;
